import { VALUELINK_MENU } from "./global-configuration-menu.model";

export enum INTEGRATIONS {
	APPSCOPE = 'appscope',
	NEXSYS = 'nexsys',
	NEXSYS_DOCUMENT_TYPES = 'nexsys/document-types',
	INSIDEMAPS = 'inside-maps',
	ACUITY = 'acuity',
	VALUTRUST = 'valutrust',
	XPANSE = 'xpanse',
	FNC = 'fnc',
	EVO = 'evo',
	CMP_ACUTIY = 'cmpacuity'
}

export enum PERMISSION {
	empty = 'empty',
	ORDERS = 'orders:access',
	ORDERS_MAPPERS = 'orders:mappers',
	ORDERS_PRODUCTS = 'orders:products',
	NEXSYS = 'nexsys:access',
	NEXSYS_ORPHAN = 'nexsys:_orphans',
	NEXSYS_RETRY = 'nexsys:retry',
	VALUTRUST = 'valutrust:access',
	VALUTRUST_RETRY = 'valutrust:retry',
	XPANSE = 'xpanse:access',
	XPANSE_RETRY = 'xpanse:retry',
	XPANSE_EVENTS = 'xpanse:events',
	ORDERS_EXTERNAL = 'oe:access',
	FNC = 'fnc:events',
	CONFIG_ACCESS = 'config:access',
	EVO = 'evo:events',
	MI_MUTUAL = 'mimutual:access',
	RELIANCE_FIRST = 'reliance:access',
	VALUE_LINK = 'valuelink:access',
	CONNEXIONS = 'connexions:access',
	LENDING_QB = 'lendingqb:access'
}

export const MAINPATHS = {
	MAIN: 'global-configuration',
	PRODUCTS: 'product/product-list',
	MAPPERS: 'nexsys-mapper-types/property-types',
	ORDERS: 'app-scope/property-types',
	MONITORS: {
		NEXSYS: 'nexsys-monitor/logs',
		VALUTRUST: 'valutrust-monitor/logs',
		XPANSE: 'xpanse-monitor/logs',
		ORDERS: 'orders-monitor/orders',
		ORPHANS: 'nexsys-legacy-monitor/logs',
		ORDERSEXTERNAL: 'order-external-monitor/logs',
		FNC: 'fnc-monitor/logs',
		MIMUTUAL: 'mi-mutual/logs',
		RELIANCEFIRST: 'reliance-first/orders',
		EMAILLIST: 'email-list',
		VALUELINK: 'valuelink-monitor/logs',
		CONNEXIONS:  'connexions-monitor/logs',
		LENDINGQB: 'lending-qb-monitor/logs'
	},
	NOT_ALLOWED: 'not-allowed',
};

export const CLASS_VALUATION_PROVIDER = 'classvaluation';